<template>
	<div
		:id="'head' + valore.id + 'canvasize'"
		style="display: flex; width: 100%; flex-wrap: wrap"
		:class="toggleBorders ? 'show-borders' : ''"
	>
		<!--
			 DOC

			 struttura documento renderizzato
			 ogni div viene poi istanziato con un'istanza vue per gestire i componenti dinamici
			 è necessario che ci sia nella root del frontend un file vue.config.js con questo contenuto
			 |---------------------------------------------------------------------------------------|
			 |                                                                                       |
			 |   module.exports = {                                                                  |
			 |     configureWebpack: {                                                               |
			 |       resolve: {                                                                      |
			 |         alias: {                                                                      |
			 |           'vue$': 'vue/dist/vue.esm.js' // 'vue/dist/vue.common.js' for webpack 1     |
			 |         }                                                                             |
			 |       }                                                                               |
			 |     }                                                                                 |
			 |   }                                                                                   |
			 |---------------------------------------------------------------------------------------|

			 -->
		<!--  header-->

		<div
			style="display: flex; width: 100%; flex-wrap: wrap"
			:key="'head' + valore.id"
			:id="'head' + valore.id"
		></div>
	</div>
</template>
<script>
import Employee from "@/modules/builder/custom-component/employee"
import Preview from "@/modules/prosemirror/component/Preview"
import WikiButton from "@/modules/flowcharts/components/wiki-button"
import Vue from "vue"
import { mapActions, mapGetters } from "vuex"
import moment from "moment"

export default {
	name: "Renderer",
	components: {
		Employee,
		moment,
		WikiButton
	},
	computed: {
		...mapGetters({
			datas: "object/datas",
			component: "object/component"
		})
	},
	data() {
		return {
			header: null,
			body: null,
			footer: null,

			/**
			 *
			 * DOC
			 * i placeholder definiscono la posizione nell'html dei diversi attributi css definiti sullo store
			 *
			 * */
			placeholders: {
				sfondo: "$sfondo_var_$sfondo",
				padding: "$padding_var_$padding",
				width: "$width_var_$width",
				height: "$height_var_$height",
				align: "$align_var_$align",
				border: "$border_var_$border"
			},
			/**
			 * DOC
			 * template è un oggetto necessario alla trasformazione da json a html
			 *
			 * la chiave è il tipo dell'elemento (type sullo store)
			 *
			 * il valore un array di stringhe che rappresentano l'html, normalmente in 2 pezzi tra i quali viene iniettato il valore corrispondente.
			 * sono quindi da costruire in base all'esigenza
			 *
			 *i placeholder per il css possono anche essere posizionati già in questo stadio
			 *
			 * la tipologia "col" comprende 3 parti invece di due, ma viene gestita dalla funzione apposita. Serve a renderizzare le colonne di dimensione adeugata in base al numero delle stesse
			 *
			 * i tag possono anche fare riferimento ad elementi vue se dichiarati più sotto
			 *
			 * tendenzialmente il documento viene costruito a righe e colonne utilizzando il più possibile flex e inline-block, block per gli elementi, salvo eccezioni
			 * */

			template: {
				generic: ["<div style='display: flex; width: 100%; flex-wrap: wrap; break-inside: avoid'>", "</div>"],
				text: ["<div>", "</div>"],
				number: ["<div>", "</div>"],
				"text-editor": ["<div>", "</div>"],
				h1: [
					"<div style=' border: $border_var_$border; display:block; width: $width_var_$width; height: $height_var_$height ;background-color: $sfondo_var_$sfondo; break-inside: avoid'><h1 style='text-align:$align_var_$align;  line-height:normal;font-size: 2em !important; break-inside: avoid '>",

					"</h1></div>"
				],
				h2: [
					"<div style='  border: $border_var_$border; display:block; width: $width_var_$width; height: $height_var_$height ;background-color: $sfondo_var_$sfondo; break-inside: avoid'><h2 style='text-align:$align_var_$align; line-height:normal; font-size: 1.5em !important; break-inside: avoid'>",
					"</h2></div>"
				],
				h3: [
					"<div style=' border: $border_var_$border; display:block; width: $width_var_$width; height: $height_var_$height ;background-color: $sfondo_var_$sfondo; break-inside: avoid'><h3 style='text-align:$align_var_$align; line-height:normal;font-size: 1.17em !important; break-inside: avoid '>",
					"</h3></div>"
				],
				img: [
					"<div style='text-align:$align_var_$align;'><img style='border: $border_var_$border; display:block; width: $width_var_$width; height: $height_var_$height ;background-color: $sfondo_var_$sfondo; break-inside: avoid' src='",
					"' /></div>"
				],
				empl: ["<employee :item='", "'></employee>"],
				"align-center": [
					"<div  style='flex-direction: row; border: $border_var_$border; display: flex; justify-content: center;  width: $width_var_$width; background-color: $sfondo_var_$sfondo; height: $height_var_$height ;break-inside: avoid'>",
					"</div>"
				],
				"align-left": [
					"<div  style='flex-direction: row; border: $border_var_$border; display: flex; justify-content: left;   width: $width_var_$width; background-color: $sfondo_var_$sfondo; height: $height_var_$height ;break-inside: avoid'>",
					"</div>"
				],
				"align-right": [
					"<div  style='flex-direction: row; border: $border_var_$border; display: flex; justify-content: right;  width: $width_var_$width; background-color: $sfondo_var_$sfondo; height: $height_var_$height ;break-inside: avoid'>",
					"</div>"
				],
				row: [
					"<div  style='flex-direction: row; border: $border_var_$border; display: flex; justify-content: center;  width: $width_var_$width; background-color: $sfondo_var_$sfondo; height: $height_var_$height ;break-inside: avoid'>",
					"</div>"
				],
				col: [
					"<div style='border: $border_var_$border; break-inside: avoid; display: block; width: ",
					"%'>",
					"</div>"
				],
				editor: [
					`<Preview class='text-preview' style=' border: $border_var_$border; display:block; max-width: 80%; width: $width_var_$width; height: $height_var_$height; break-inside: avoid; background-color: $sfondo_var_$sfondo; margin:$padding_var_$padding' :route='${JSON.stringify(
						this.$route.fullPath
					)}' :documentId='${
						this.$route.params.documentId ? JSON.stringify(this.$route.params.documentId) : '""'
					}' documentId='' value='`,
					"'> </Preview>"
				]
			}
		}
	},
	methods: {
		...mapActions({
			pushEl: "object/pushEl"
		}),
		renderCol(n_col, el_to_insert, settings) {
			/**
			 * DOC
			 * la funzione divide 100 per il numero di colonne, arrotonda e poi usando il template "col"
			 * ne crea tante quante il risultato e ci inietta dentro la larghezza in percentuale e il valore corrispondente preventivamente passato come stringa [el_to_insert]
			 * nel caso fosse possibile una % per la dimesnione delel colonne, viene effettuata la sostiuzione della percentuale con col_span (de default è a percentuale che esce con 100/ numero colonne)
			 *
			 * */
			const max_col = 24
			var col_span = Math.floor(100 / n_col)
			var returned = ""
			for (let i = 0; i < n_col; i++) {
				if (settings.column_width) {
					col_span = (settings.column_width[i] + "").replaceAll("%", "")
				}
				returned +=
					this.template["col"][0] +
					col_span +
					this.template["col"][1] +
					el_to_insert[i] +
					this.template["col"][2]
			}
			return returned
		},
		async readFileAsDataURL(file) {
			let result_base64 = await new Promise(resolve => {
				let fileReader = new FileReader()
				fileReader.onload = e => resolve(fileReader.result)
				fileReader.readAsDataURL(file)
			})

			return result_base64.split(",")[1]
		},
		async unpackWiki(val) {
			return (
				"<div class='wiki-button'><wiki-button :item='\"" +
				(await this.pushEl({ val: JSON.parse(JSON.stringify(val)), id: this.valore.id })) +
				"\"'></wiki-button></div>"
			)
		},

		async unpackVal(array, variable) {
			/**
			 * DOC
			 * la funzione inietta il valore passato [variable] nell'array di template scelto [array]
			 * se il valore è un oggetto, e quindi il template è un elemento vue, viene stringhifato per essere accettato come props in fase di render
			 *
			 **/
			// variable = encodeURIComponent(variable)
			if (typeof variable === "object") {
				variable = await this.pushEl({ val: JSON.parse(JSON.stringify(variable)), id: this.valore.id })
			}
			return array[0] + variable + array[1]
		},
		async recursiveUnpack(datas) {
			/**
			 * DOC
			 * funzione ricorsiva che si occupa di scompattare il json in html
			 * completate tutte le iterazioni ritorna solo html già pronto per essere iniettato
			 * puoò essere migliorata dal punto dell'efficienza? non lo so, forse si
			 *
			 * ATTENZIONE
			 * mantenere le casistiche in caso di ottimizzazione
			 * ATTENZIONE
			 *
			 * la spiegazione della funzione viene svolta nel contenuto stesso, il punto di partenza è uno dei tre blocchi principali del json [datas]
			 * [toreturn] è il risultato sotto forma di stringa
			 *
			 * */

			var toreturn = ""
			for await (const el2 of datas) {
				/**
				 * DOC
				 *
				 * a seguito di richieste è stato necessario inserire una parte di wiki sui singoli nodi
				 *
				 * se il blocco presenta una wiki, viene elaborata e salvata su toreturn
				 * NB: attualmente solo i blocchi salvati offrono questa possibilità, è comunque possibile espandere ai blocchi normali
				 *
				 * */

				if (el2.wiki && this.logged) {
					toreturn += await this.unpackWiki(el2.wiki)
				}

				let ind2 = datas.indexOf(el2)
				var sub_text = ""
				/**
				 * DOC
				 * controllo se l'elemento ha figli, e quindi è una riga o un elemento di allineamento (center, left, right)
				 * */
				if (el2.items) {
					if (el2.items.length > 0) {
						/**
						 * DOC
						 * se presenta figli, faccio un doppio controllo per verificare che non ci sia un errore, nel caso ignoro l'elemento
						 *
						 * per renderizzare le colonne, mi affido a un array di lunghezza numero di colonne necessario alla funzione renderCol
						 * il contenuto è un html renderizzato in maniera ricorsiva
						 * */
						var col_children = []
						for await (const el3 of el2.items) {
							let indx = el2.items.indexOf(el3)
							sub_text = await this.recursiveUnpack(el3)
							col_children[indx] = sub_text
						}
						/**
						 * DOC
						 * se è figlio unico, l'elemento non è una riga ma un elemento di allineamnto, di conseguenza forzo la width a 90% ****
						 *
						 * 			NOTA DI BEATRICE
						 * 			ho messo che la width è 100% anziché 90 perché i blocchi salvati venivano visualizzati più piccoli del resto del testo
						 *			in questa maniera gli elementi "detra" e "sinistra" non funzionano correttamente, bisogna farlo tramite stile
						 *
						 * in caso comntrario renderizzo le colonne
						 *
						 * fatto questo, inietto il valore delle colonne [sub_text] nell'elemento riga corrispondente, ci inietto gli stili come oggetto parent e aggiungo a variabile di ritorno
						 *
						 * */
						if (col_children.length === 1) {
							sub_text = "<div style='display:inline-block; width: 100%;'>" + sub_text + "</div>"
							/*
							 *TODO sulla riga sotto non mi ricordo se è += o semplicemente =, da verificare. A logica direi +=
							 * */
							toreturn += this.injectStyle(
								await this.unpackVal(this.template[el2.type], sub_text),
								el2.setting
							)
						} else {
							sub_text = this.renderCol(col_children.length, col_children, el2.setting)
							toreturn += this.injectStyle(
								await this.unpackVal(this.template[el2.type], sub_text),
								el2.setting
							)
						}
					} else {
						/**
						 *
						 * 42
						 *
						 * */
					}
				} else {
					/**
					 * DOC
					 * l'elemento non ha figli, procedo quindi a scompattarne il valore (unpackVal) nell'elemento corrispondente e iniettarci come parent un'ulteriore classe con gli stili.
					 * dopodichè viene accodato alla variabile di ritorno
					 * */
					toreturn += this.injectStyle(await this.unpackVal(this.template[el2.type], el2.value), el2.setting)
				}
			}
			return toreturn
		},
		injectStyle(element, style) {
			/**
			 * DOC
			 * aggiunge elemento wrapper con alcune carratteristiche css, poi le sostituisce
			 *
			 * */
			element =
				'<div style=" padding: $padding_var_$padding; flex-direction: row; display: flex;  width: 100% ; justify-content: $align_var_$align;  ">' +
				element +
				"</div>"
			var that = this
			Object.keys(style).forEach(function (el) {
				if (el == "width" && style[el] == "auto") {
					style[el] = "100%"
				}
				element = element.replaceAll(that.placeholders[el], style[el])
				if (that.toggleBorders) {
					element = element.replaceAll(that.placeholders["border"], "1pt solid #ccc")
				}
			})
			return element
		}
	},
	async mounted() {
		var inizio = moment.now()
		/**
		 * DOC
		 * aggiunge cose all'html dopo averli scompattati
		 * poi li renderizza come elementi vue per le cose dinamiche
		 * prende lo store già istanziato, quindi è possibile per gli elementi utilizzare tutti gli store vuex presenti
		 *
		 *  i componenti vanno però dichiarati (vedi Employee)
		 * */
		//necessario vue.config.js su root per on-demand compiler di vue
		var html = await this.recursiveUnpack(this.dati[0].items)
		this.header = "<div  style='display: flex; width: 100%; flex-wrap: wrap;'>" + html + "</div>"
		var res = await Vue.compile(this.header)

		await new Vue({
			el: "#head" + this.valore.id,
			render: res.render,
			staticRenderFns: res.staticRenderFns,
			components: {
				Employee,
				Preview,
				WikiButton
			},
			store: this.$root.$store
		})

		var inizio2 = moment.now()
		this.$emit("show")
	},
	props: {
		toggleBorders: {},
		dati: {
			required: true,
			type: Array
		},
		valore: {
			required: false,
			default() {
				return { id: 0 }
			}
		},
		logged: {}
	}
}
</script>
<style lang="scss" scoped>
/*.document-container > table > tbody > tr > td {*/
/*    border: 1px solid #000 !important;*/
/*    border-collapse: collapse !important;*/
/*    padding: 10px;*/
/*}*/
/*.document-container > table > tbody > tr, .document-container > table {*/
/*    width: 100%;*/
/*    border-collapse: collapse;*/
/*}*/

table {
	border-collapse: collapse;
	table-layout: fixed;
	width: 100%;
	margin: 0;
	overflow: hidden;
}
td,
th {
	min-width: 1em;
	border: 2px solid #ced4da;
	padding: 3px 5px;
	vertical-align: top;
	box-sizing: border-box;
	position: relative;
}

th {
	font-weight: bold;
	text-align: left;
	background-color: #f1f3f5;
}

.selectedCell:after {
	z-index: 2;
	position: absolute;
	content: "";
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(200, 200, 255, 0.4);
	pointer-events: none;
}

.column-resize-handle {
	position: absolute;
	right: -2px;
	top: 0;
	bottom: -2px;
	width: 4px;
	background-color: #adf;
	pointer-events: none;
}

.show-borders {
	border: 1pt solid #ccc;
	border-radius: 3px;
}
</style>
<style lang="css">
.rend-div {
	display: flex;
	width: 100%;
	flex-wrap: wrap;
}
</style>
